import { NoteAdd, Email, Cancel, Task, Comment, Delete } from "@mui/icons-material"

const MapEventToIcon = (eventName?: string | null, fontSize?: "small" | "inherit" | "large" | "medium") => {
  switch (eventName) {
    case "InvoiceCreated":
      return <NoteAdd fontSize={fontSize} />
    case "InvoiceSent":
      return <Email fontSize={fontSize} />
    case "InvoicePaid":
      return <Task fontSize={fontSize} />
    case "InvoiceCanceled":
      return <Cancel fontSize={fontSize} />
    case "CommentForInvoiceAdded":
      return <Comment fontSize={fontSize} />
    case "CommentForInvoiceRemoved":
      return <Delete fontSize={fontSize} /> 
    case "InvoiceReminderCreated":
      return <NoteAdd fontSize={fontSize} /> 
    case "InvoiceReminderSent":
      return <Email fontSize={fontSize} />  
    case "ReverseInvoiceSent":
      return <Email fontSize={fontSize} />  
    default:
      break;
  }
}

export default MapEventToIcon